import { commentManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher];

const commentManagementRouteMetadata: IRouteMetadataObj<
  typeof commentManagementRoutesObj
> = {
  list: {
    title: "commentManagement.index.title",
    description: "commentManagement.index.description",
    lazy: () => import("@/pages/commentManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "QuestionAnswerLine",
    breadcrumbs: [],
    permission,
  },
};

export const commentManagementRoutes = createRoute<
  typeof commentManagementRoutesObj
>(commentManagementRoutesObj, commentManagementRouteMetadata);
